import { usePathname } from "next/navigation"

export default usePathname
